module.exports = __webpack_public_path__ + "img/icon-arrow-triangle-shadow2.3e6a2e0b.svg";